import { ActivityEntityName } from '@jms/model';
import type { EntityManifest, EntityManifestShareOptions } from '@workbuddy/services/entities/entity.manifest';
import { getManifest } from '@workbuddy/services/entities/entity.manifest.registry';

/** Manual share toggles to render for one child under one parent; every flag is decided. */
export type ResolvedShareOptions = Readonly<Required<EntityManifestShareOptions>>;

/** Both sides must opt in: the child declares `shareable`, the parent names which toggles it offers that child. */
export function resolveShareOptionsFromManifests(child: Pick<EntityManifest, 'entity' | 'shareable'> | undefined, parent: Pick<EntityManifest, 'shareRelations'> | undefined): ResolvedShareOptions | null {

  if (!child?.shareable) {
    return null;
  }

  const declared = parent?.shareRelations?.[child.entity];
  const resolved: ResolvedShareOptions = {
    customer: declared?.customer === true,
    field: declared?.field === true,
    sensitive: declared?.sensitive === true,
  };

  return resolved.customer || resolved.field || resolved.sensitive
    ? resolved
    : null;
}

/** Domain-resolved: a domain manifest that omits sharing yields no share control there. */
export function resolveShareOptions(childEntity: ActivityEntityName, parentEntity: ActivityEntityName): ResolvedShareOptions | null {

  return resolveShareOptionsFromManifests(getManifest(childEntity), getManifest(parentEntity));
}
